module.exports = __webpack_public_path__ + "img/p2.14f019ad.png";